/**
 * Configuration constants for behavioral interview component
 */

// Focus areas for behavioral interviews
export const FOCUS_AREAS = [
  'motivation',
  'proactive',
  'unstructured_environment',
  'perseverance',
  'conflict_resolution',
  'empathy',
  'growth',
  'communication',
];

// Top tech companies for random selection
export const TOP_TECH_COMPANIES = [
  'Google',
  'Meta',
  'Microsoft',
  'Amazon',
  'Apple',
  'Netflix',
  'Tesla',
  'Salesforce',
  'Adobe',
  'Uber',
  'Airbnb',
  'Spotify',
  'Stripe',
  'Shopify',
  'Palantir',
  'Snowflake',
  'Datadog',
  'Atlassian',
  'Slack',
  'Zoom',
];

/**
 * Select a random company from the list
 * @returns {string} Random company name
 */
export const getRandomCompany = () =>
  TOP_TECH_COMPANIES[Math.floor(Math.random() * TOP_TECH_COMPANIES.length)];

/**
 * Format focus area names for display
 * @param {string} area - Focus area key
 * @returns {string} Formatted display name
 */
export const formatFocusArea = (area) => {
  const areaMap = {
    motivation: 'Motivation',
    proactive: 'Proactive',
    unstructured_environment: 'Unstructured Environment',
    perseverance: 'Perseverance',
    conflict_resolution: 'Conflict Resolution',
    empathy: 'Empathy',
    growth: 'Growth',
    communication: 'Communication',
  };
  return areaMap[area] || area.replace('_', ' ').replace(/\b\w/g, (l) => l.toUpperCase());
};
